exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content[data-v-5a3e11a7]{\n    width: 100% !important;\n    position: absolute !important;\n}\n.show-document-generate[data-v-5a3e11a7] {\n    display: list-item !important;\n    opacity: 1 !important;\n    background-color: #3c29297a !important;\n    height: 138%;\n}\n#detailEdit .ql-editor[data-v-5a3e11a7] { min-height:100px\n}\n.wangEditor-txt[data-v-5a3e11a7] {\n    min-height:100px;\n}\n", ""]);

// exports
